import ArticleLayout from "@/components/feature/ArticleLayout";
import { seoArticles } from "@/mocks/articles";

export default function ArticleDeals() {
  const article = seoArticles.find((a) => a.slug === "najlepsze-okazje-kakobuy-spreadsheet-2026")!;
  return <ArticleLayout article={article} />;
}